import md5 from 'md5';
import { DogModelConfig } from '@/components/Avatar3D/interfaces/DogModel';
import { HumanModelConfig } from '@/components/Avatar3D/interfaces/HumanModel';

export default function getAvatarHash(
  model: DogModelConfig | HumanModelConfig,
) {
  return md5(JSON.stringify(model));
}
